import { useRouter } from 'next/router'
import { useEffect } from 'react'
import { IPagination } from '../../types'
import { Arrow } from './Arrow'
import { Container, PagerButton } from './Pager.styles'
import { config } from '../../lib'

type Props = {
  pager: IPagination
}

const pageUrl = (page: number, base: string) =>
  base?.replace('%#%', page.toString())

export const PagerButtonPrefetch = ({
  fake_key,
  href,
  active,
  page,
  shouldPrefetch,
}: {
  fake_key: number
  href: string
  active: boolean
  page: number
  shouldPrefetch: boolean
}) => {
  const router = useRouter()
  useEffect(() => {
    shouldPrefetch && router.prefetch(href)
  }, [href, router, shouldPrefetch])
  return (
    <PagerButton
      key={'p' + fake_key}
      href={href}
      active={active}
      prefetch={false}
    >
      {page}
    </PagerButton>
  )
}

export const Pager = ({ pager }: Props) => {
  if (!pager) {
    return null
  }

  const blockSize = 4

  const { base, max_page } = pager

  const current_page = Math.max(1, Math.min(pager.current_page, max_page))

  const pagerValues = getPagerValues(current_page, max_page)

  const pagerElements = pagerValues.map(page => (
    // <PagerButtonPrefetch
    //     key={page}
    //     fake_key={page}
    //     href={pageUrl(page, base)}
    //     active={page === current_page}
    //     page={page}
    //     shouldPrefetch={index == 1}
    // />
    <PagerButton
      key={'p' + page}
      href={pageUrl(page, base)}
      active={page === current_page}
    >
      {page}
    </PagerButton>
  ))

  const rightEdge = Math.min(
    Math.ceil(current_page / blockSize) * blockSize,
    max_page
  )

  const leftEdge = Math.max(
    Math.floor((current_page - 1) / blockSize) * blockSize + 1,
    1
  )

  const nextPage =
    current_page < rightEdge ? rightEdge : Math.min(rightEdge + 1, max_page)

  const prevPage =
    current_page > leftEdge ? leftEdge : Math.max(leftEdge - 1, 1)

  return (
    <Container>
      <Arrow
        direction='left'
        active={current_page > 1}
        link={pageUrl(prevPage - 1, base)}
      />
      {pagerElements}
      <Arrow
        direction='right'
        active={leftEdge + blockSize < config.maxPaginationPage}
        link={pageUrl(nextPage + 1, base)}
      />
    </Container>
  )
}

// render series of 4 pages: 1 - 4, 5 - 8, 9 - 12, 13 - 16
// highlight current page in respective range
const getPagerValues = (current_page: number, max_page: number) => {
  // number or string array type
  const pagerValues = [current_page]
  const pagesToLeft = (current_page - 1) % 4
  const pagesToRight = 3 - pagesToLeft

  for (let i = 1; i <= pagesToRight && current_page + i <= max_page; i++) {
    pagerValues.push(current_page + i)
  }

  for (let i = 1; i <= pagesToLeft && current_page - i >= 1; i++) {
    pagerValues.unshift(current_page - i)
  }

  if (pagerValues.length === 4) {
    return pagerValues
  }

  for (
    let i = pagerValues[pagerValues.length - 1] + 1;
    i <= max_page && pagerValues.length < 4;
    i++
  ) {
    pagerValues.push(i)
  }

  for (let i = pagerValues[0] - 1; i >= 1 && pagerValues.length < 4; i--) {
    pagerValues.unshift(i)
  }

  return pagerValues
}
export default Pager
